<template>
  <div>
    <div>
      <div class="search-box">
        <div class="tip-box">
          <img
            src="@/assets/images/new_icon_waring_yellow.png"
            style="
              display: inline-block;
              float: left;
              position: absolute;
              width: 14px;
              height: 14px;
              color: #ffffff;
              margin: 14px 4px 0 3px;
            "
          />
          <span style="margin-left: 24px; color: #333"
            >此功能为京东官方功能，必须报备店铺签名后才可以筛选出数据，营销效果分析需要第二天才可以查看！</span
          >
          <span
            :style="{ color: globalBG }"
            style="cursor: pointer"
            @click="toSet"
            >去设置</span
          >
        </div>
        <el-form
          ref="formSearch"
          :inline="true"
          :model="form"
          label-width="120px"
        >
          <el-form-item label="活动主题:">
            <el-input
              size="small"
              v-model="form.activityTitle"
              placeholder="请输入活动主题"
            ></el-input>
          </el-form-item>
          <el-form-item label="短信内容:">
            <el-input
              size="small"
              v-model="form.content"
              placeholder="请输入短信内容"
            ></el-input>
          </el-form-item>
          <el-form-item label="发送时间:">
            <div class="my_select_time">
              <el-date-picker
                prefix-icon="no_icon"
                v-model="form.sendStartTime"
                type="datetime"
                :placeholder="'选择日期时间'"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 120px; font-size: 12px"
                class="time1"
                :clearable="false"
              ></el-date-picker>
              <div class="time_to_text" style="margin-top: 1px !important">
                至
              </div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="form.sendEndTime"
                type="datetime"
                :placeholder="'选择日期时间'"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 145px; font-size: 12px"
                class="time2"
                :clearable="false"
              ></el-date-picker>
              <i
                class="el-icon-circle-close date_icon1"
                @click="clearTimeSendTime()"
              ></i>
              <img
                src="@/assets/images/select_date.svg"
                alt
                class="date_icon2"
              />
            </div>
          </el-form-item>
        </el-form>
        <div class="el_btn">
          <el-button
            size="small"
            :disabled="tableLoding"
            class="search"
            @click="
              form.current = 1;
              submitForm('formSearch');
            "
          >
            <i
              class="el-icon-search"
              style="display: inline-block; width: 14px; height: 12px"
            ></i>
            查询
          </el-button>
          <el-button size="small" class="reset" @click="resetForm"
            >重置</el-button
          >
        </div>
      </div>
      <div class="table-box">
        <div class="batchUpload">
          <el-button class="status_btn3" @click="staVisible = true">批量下载</el-button>
        </div>
        <div style="color: #fe4d45; padding-bottom: 5px;">
          注意：短信扣费先按照提交条数预扣相应短信条数，余额会减少，发送后4~7天会按照京东实际返回的短信状态报告成功扣费，短信条数多退少补。
        </div>
        <el-table
          ref="table"
          :data="tableData"
          v-loading="tableLoding"
          tooltip-effect="light"
          style="width: 100%; border: 1px solid #eee"
        >
          <el-table-column
            label="序号"
            type="index"
            width="80px"
          ></el-table-column>
          <el-table-column
            label="活动主题"
            prop="activityTitle"
          ></el-table-column>
          <el-table-column
            key="content"
            label="短信内容"
            min-width="400px"
            prop="content"
            width="400"
          >
            <template slot="header" slot-scope="scope">
              <span>短信内容</span>
              <span
                v-if="!allShow"
                :style="{ color: globalBG }"
                @click="allShow = true"
                class="table-message"
                >(展开全部)</span
              >
              <span
                v-if="allShow"
                :style="{ color: globalBG }"
                @click="allShow = false"
                class="table-message"
                >(单行显示)</span
              >
            </template>
            <template slot-scope="scope">
              <div>
                <el-tooltip
                  class="item"
                  effect="light"
                  :content="scope.row.content"
                  placement="top"
                >
                  <div class="hoveTitle" v-show="!allShow">
                    {{ scope.row.content }}
                  </div>
                </el-tooltip>
                <div class="hoveTitleShowMore" v-show="allShow">
                  {{ scope.row.content }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="发送时间"
            key="sendTime"
            prop="sendTime"
          ></el-table-column>
          <el-table-column
            label="实际触达人数"
            key="sendNum"
            prop="sendNum"
          ></el-table-column>
          <el-table-column label="操作" width="160">
            <template slot-scope="scope">
              <el-button
                type="text"
                style="width: 60px"
                class="operation"
                @click="handeleEffect(scope.row)"
                >效果分析</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页器 -->
        <div>
          <el-pagination
            background
            style="text-align: right; margin-top: 20px"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="form.current"
            :page-sizes="[10, 20, 30, 50, 100, 500]"
            :page-size="form.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="crowdTotal"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog title="统计时间" width="650px" :visible.sync="staVisible">
      <el-form>
        <el-form-item label="效果数据时间">
          <el-select v-model="staValue">
            <el-option
              v-for="(item, index) in statiType"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-input 
            style="width: 186px; margin-left: 10px"
            v-model="customValue"
            v-if="staValue === ''"
            @keyup.native="limitInput($event)"
          >
            <template slot="suffix">
              天
            </template>
          </el-input>
        </el-form-item>
      </el-form>
      <div class="footer">
        <button class="cancel" @click="staVisible = false">取消</button>
        <button class="confirm" @click="batchUpload">确定</button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getSmsRecordPage } from "@/api/intelligentMarket/index";
export default {
  name: "",
  data() {
    return {
      staVisible: false,
      staValue: "7",
      customValue: '',
      statiType: [
        {
          label: "近7天",
          value: "7",
        },
        {
          label: "近15天",
          value: "15",
        },
        {
          label: "近30天",
          value: "30",
        },
        {
          label: "自定义",
          value: "",
        },
      ],
      form: {
        size: 10,
        current: 1,
        activityTitle: "",
        content: "",
        sendStatus: 101,
        sendStartTime: "",
        sendEndTime: "",
      },
      allShow: false,
      allShowCrowd: false,
      sendStatusList: [
        {
          label: "待审核",
          value: 1,
        },
        {
          label: "待发送",
          value: 3,
        },
        {
          label: "审核未通过",
          value: 4,
        },
        {
          label: "已取消",
          value: 5,
        },
        {
          label: "发送中",
          value: 100,
        },
        {
          label: "已发送",
          value: 101,
        },
        {
          label: "发送失败",
          value: 102,
        },
      ],
      tableData: [],
      tableLoding: false,
      crowdTotal: 0,
            mytimestart:"",
      mytimeend:"",
    };
  },
  computed: {
    ...mapState({
      globalBG: "globalBG",
    }),
  },
  mounted() {
    this.time();
    this.queryList();
  },
  methods: {
     limitInput(event) {
      var value = event.target.value;
      if (value == '0') {
        event.target.value = ''
      } else if (value >= 30) {
        event.target.value = 30
      } else {
        event.target.value = value.replace(/[^\d]/g, '')
      }
    },
     time() {
      let yy = new Date().getFullYear(); //当前年份
      let mm =
        new Date().getMonth() + 1 < 10
          ? "0" + (new Date().getMonth() + 1)
          : new Date().getMonth() + 1;
      let dd =
        new Date().getDate() < 10
          ? "0" + new Date().getDate()
          : new Date().getDate(); //当前天数
      this.mytimestart = this.getDateStr(-30) + " 00:00:00";
      this.mytimeend = `${yy}-${mm}-${dd} 23:59:59`;
      this.form.sendStartTime = this.mytimestart;
      this.form.sendEndTime = this.mytimeend;
    },
     //批量下载
    batchUpload() {
      var dayNum = this.staValue;
      if (this.staValue === '') {
        dayNum = this.customValue;
        if (!dayNum) {
          this.$message.warning('请输入天数！')
          return;
        }
      }
      let param = {
        activityTitle: this.form.activityTitle,
        content: this.form.content,
        dayNum: dayNum,
        source: 3
      };

      if (this.form.sendStartTime) {
        param.sendTimeStart = this.form.sendStartTime;
      }
      if (this.form.sendEndTime) {
        param.sendTimeEnd = this.form.sendEndTime;
      }
      let paramStr = "";
      for (var key in param) {
        let temp = "&" + key + "=" + param[key];
        paramStr += temp;
      }
      paramStr = paramStr.substr(1);
      let elem = document.createElement("a");
      elem.style.display = "none";
      let url =
        "/jd-yusms/sms/marketing/effect/analyze/official/select/export?" +
        paramStr;
      elem.href = url;
      document.body.appendChild(elem);
      elem.click();
      document.body.removeChild(elem);
      this.staVisible = false;
    },
    queryList() {
      this.tableLoding = true;
      getSmsRecordPage(this.form).then((res) => {
        this.tableLoding = false;
        if (res.code == "1") {
          this.tableData = res.data.records;
          this.crowdTotal = res.data.total;
        }
      });
    },

    handeleEffect(row) {
      this.officialObj = {
        outerId: row.id,
        source: "INTELLIGENT_MARKETING",
        sendTime: row.sendTime,
      };
      this.$emit("showEffect", this.officialObj);
    },
    handleSizeChange(val) {
      this.form.size = val;
      this.submitForm();
    },
    handleCurrentChange(val) {
      this.form.current = val;
      this.submitForm();
    },

    submitForm(name) {
      this.queryList();
    },
    resetForm() {
      this.form = {
        size: 10,
        current: 1,
        activityTitle: "",
        content: "",
        sendStatus: 101,
        sendStartTime: "",
        sendEndTime: "",
      };
      this.queryList();
    },
    // 精准营销的取消发送
    handleCancelPrecision(row, index) {
      this.$confirm("确定要取消吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
      }).then(() => {
        var param = {
          sendTime: row.sendTime,
          activityRecordId: row.activityRecordId,
        };
        cancelSendSms(param).then((res) => {
          if (res.code == "1") {
            this.$message.success("取消发送成功");
            this.submitForm();
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },

    toSet() {
      let routeUrl = this.$router.resolve({
        path: "/backstage/signature_management/signature_report_official",
      });
      window.open(routeUrl.href, "_blank");
    },
    clearTime1() {
      this.form.submitTimeStart = "";
      this.form.submitTimeEnd = "";
    },
    clearTimeSendTime() {
      this.form.sendStartTime = "";
      this.form.sendEndTime = "";
    },
  },
};
</script>

<style scoped lang="scss">
/deep/ .el-dialog__body{
  padding-bottom: 20px!important;
}
/deep/ .el-table th.is-leaf {
  height: 50px;
}
 .batchUpload {
    padding-bottom: 10px;
    .status_btn3 {
      width: 98px;
      padding: 5px 12px;
      height: 32px;
      color: #ffffff;
      border-radius: 3px;
      border: 1px solid #fe4d45;
      background-color: #fe4d45;
      &:hover {
        color: #fff;
        opacity: 0.9;
        background-color: #fe4d45;
      }
      &:active {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }
  }
.footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 20px;
  .cancel,
  .confirm {
    width: 98px;
    font-size: 14px;
    height: 32px;
  }
  .cancel {
    margin-right: 8px;
    color: #999999;
    border: 1px solid #cccccc;
    background-color: #fff;
    &:hover {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
  .confirm {
    color: #ffffff;
    background-color: #fe4d45;
    &:hover {
      color: #fff;
      opacity: 0.9;
      background-color: #fe4d45;
    }
  }
}
/** 表单搜索  */
.search-box {
  margin-top: 20px;
  padding-bottom: 20px;
  .el_btn {
    text-align: center;
    .search {
      width: 98px;
      height: 32px;
      font-size: 14px;
      border-radius: 3px;
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff;
      &:hover {
        color: #fff;
        border: 1px solid #fff;
        background-color: #fe4d45;
      }
    }
    .reset {
      width: 98px;
      height: 32px;
      font-size: 14px;
      border-radius: 3px;
      color: #666666;
      border: 1px solid #dddddd;
      background-color: #fff;
      &:hover {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }
  }
  .el-input,
  .el-select {
    width: 280px;
  }
  .my_select_time {
    display: flex;
    align-items: center;
  }
}
/** 表格内容 */
.table-box {
  // margin: 20px;
  margin-top: 20px;
  padding: 0 28px 24px 28px;
  .control-button {
    .el-button {
      width: 65px;
      margin-left: 0 !important;
    }
    .operation {
      cursor: pointer;
      color: #7f85e9;
      &:hover {
        color: #fe4d45;
      }
    }
  }
}
.question_icon {
  width: 14px;
  height: 14px;
  color: #7f85e9 !important;
  display: inline-block;
  line-height: 12px !important;
  text-align: center;
  border-radius: 14px;
  border: 1px solid #7f85e9;
  font-size: 12px !important;
  font-weight: normal !important;
  margin-left: 8px;
  &:hover {
    color: #fe4d45 !important;
    border: 1px solid #fe4d45;
  }
}
/* 短信记录/效果分析  */
.tip-box {
  padding-left: 24px;
  text-align: left;
  line-height: 21px;
  font-size: 14px;
  margin-top: 12px;
  color: #999999;
  background: #fffaee;
  position: relative;
  margin: 20px 28px 20px 28px;
  line-height: 42px;
  .warning-icon {
    color: #fe8f8a;
    font-size: 14px;
    position: absolute;
    left: 5px;
    top: 13px;
  }
}
</style>